<template>
    <div class="position-box depositTips">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('langNew.ts')}}</div>
        </div>
        <div id="depositTips" class="cotainer">
            <div class="cont">
              <div class="img-box">
                <img v-if="!theme" class="img" src="@/assets/new2/dagou_white.png" alt="">
                <img v-else class="img" src="@/assets/new2/dagou_light.png" alt="">
              </div>
              <div class="t1">{{$t('langNew.czsqytj')}}</div>
              <div class="t2">{{$t('langNew.czdzts')}}</div>
              <div class="t3" @click="service">{{$t('index.zxkf')}}</div>
              <div class="btn-kf btn-bg" @click="service">{{$t('index.zxkf')}}</div>
              <div class="btn-fh btn-bg" @click="goHome">{{$t('langNew.fhsy')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'depositTips',
    data () {
      return {
        theme: false,
        service_link: '',
      }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {
      this.getParams()
    },
    methods: {
      back(){
          this.$router.push('/deposit')
      },
      goHome(){
          this.$router.push('/index')
      },
      service(){
        if(!this.service_link) return;
        var kfUrl;
        var userId = localStorage.getItem('userId');
        if(userId){
          var userInfo = {
            "uid":userId,
            "name":userId
          }
          var userUrl = encodeURIComponent(JSON.stringify(userInfo));
          kfUrl = this.service_link + "&userInfo=" + userUrl;
        }else{
          kfUrl = this.service_link;
        }
        this.$router.push({ path: '/service', query: { url: kfUrl } })
      },
      getParams(){
        this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
            let resData = res.data.data;
            this.service_link = resData.filter((item) =>{
                if(item.key == 'online_service'){
                    return item
                }
            })[0].value;
        }).catch(function(err){
            console.log(err)
        })
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #f9f9f9;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .cont{
      margin: .32rem;
      padding: .9rem .54rem 1.5rem;
      color: #7f7f7f;
      background: #fff;
      border-radius: .2rem;
      text-align: center;
    }
    .cotainer .cont .img-box{
      text-align: center;
    }
    .cotainer .cont .img{
      width: 4.62rem;
    }
    .cotainer .cont .t1{
      margin-top: .5rem;
      color: #000;
      font-size: .6rem;
      font-weight: bold;
    }
    .cotainer .cont .t2{
      margin-top: .5rem;
      font-size: .45rem;
    }
    .cotainer .cont .t3{
      margin-top: .2rem;
      color: #4458ed;
      font-size: .45rem;
    }
    .cotainer .cont .btn-kf{
      margin-top: 1rem;
    }
    .cotainer .cont .btn-fh{
      margin-top: .5rem;
      color: #000;
      border: 1px solid #000;
      background: #fff;
    }
</style>




// WEBPACK FOOTER //
// src/pages/depositTips.vue